import { createSelector } from 'reselect';
import { getBasicDetailsForm } from './basicDetails';
import { getIncidentDetailsForm } from './incidentDetails';
import {
    AHOC_REQUIRED_DOCUMENTS,
    BASIC_DETAILS_LABELS,
    INCIDENT_DEATAILS_LABELS,
} from '../../actions/allsureHomeClaim/types';
import { getUploadDocumentForm } from './uploadDocuments';
import { getClaimName } from './routing';

export const getBasicDetailsSummary = createSelector(getBasicDetailsForm, (basicDetailsForm) => {
    return Object.keys(BASIC_DETAILS_LABELS).flatMap((fieldKey) =>
        basicDetailsForm[fieldKey].value
            ? {
                  label: BASIC_DETAILS_LABELS[fieldKey],
                  value: basicDetailsForm[fieldKey].value ?? '-',
              }
            : []
    );
});

export const getIncidentDetailsSummary = createSelector(getIncidentDetailsForm, (incidentDetailsForm) => {
    return Object.keys(INCIDENT_DEATAILS_LABELS).flatMap((fieldKey) =>
        incidentDetailsForm[fieldKey].value
            ? {
                  label: INCIDENT_DEATAILS_LABELS[fieldKey],
                  value: incidentDetailsForm[fieldKey].value ?? '-',
              }
            : []
    );
});
export const getDocmuentsSummary = createSelector(getUploadDocumentForm, (documentsForm) => {
    return Object.keys(documentsForm).flatMap(
        (fieldKey) =>
            // incidentDetailsForm[fieldKey].value?
            ({
                label: (AHOC_REQUIRED_DOCUMENTS[fieldKey] ?? AHOC_REQUIRED_DOCUMENTS.additionalDocument).title,
                value: documentsForm[fieldKey].fileName ?? '-',
            })
        // : []
    );
});

export const getClaimDetailsSummary = createSelector(
    getIncidentDetailsSummary,
    getBasicDetailsSummary,
    getDocmuentsSummary,
    getClaimName,
    (incidentDetailsSumamry, basicDetailsSummary, documentsSummary, claimName) => {
        const claimDetailsSummary = [
            {
                key: 'claimDetails',
                title: 'Claim Details',
                data: [{ value: claimName, label: 'Claim name' }],
            },
            {
                key: 'basicDetails',
                title: 'Basic Details',
                data: basicDetailsSummary,
                editable: true,
            },
            {
                key: 'incidentDetails',
                title: 'Incident Details',
                data: incidentDetailsSumamry,
                editable: true,
            },
            {
                key: 'documentDetails',
                title: 'Document Details',
                data: documentsSummary,
                editable: true,
            },
        ];
        return claimDetailsSummary;
    }
);
